import { useTranslation } from 'react-i18next';

/** Monochrome Microsoft 4-square symbol per Figma V4.6 (26x26, #ABABAB). */
export function MicrosoftLogo(): React.ReactElement {
  const { t } = useTranslation('aita');
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" role="img" aria-label={t('chrome.logo_alt', 'Microsoft')}>
      <rect x="0" y="0" width="12.25" height="12.25" fill="#ABABAB" />
      <rect x="13.75" y="0" width="12.25" height="12.25" fill="#ABABAB" />
      <rect x="0" y="13.75" width="12.25" height="12.25" fill="#ABABAB" />
      <rect x="13.75" y="13.75" width="12.25" height="12.25" fill="#ABABAB" />
    </svg>
  );
}
